import ArrowDown from "@components/Icons/ArrowDown";
import HeaderToggleButton from "@components/Accordion/Item/HeaderToggleButton";

const AccordionItemHeader = ({
  isExpanded,
  isToggleable,
  hasToggleButton = false,
  renderToggleButton,
  onToggle,
  children,
}) => {
  if (!hasToggleButton) {
    return (
      <div
        className={`flex items-center justify-between py-7 ${
          isToggleable ? "cursor-pointer" : ""
        }`}
        onClick={onToggle}
      >
        <div>{children}</div>

        {isToggleable && (
          <span
            className={`transition-transform ease-linear ${
              isExpanded ? "rotate-180" : "rotate-0"
            }`}
          >
            <ArrowDown width="16px" height="16px" />
          </span>
        )}
      </div>
    );
  }

  const toggleButton = (renderToggleButton &&
    renderToggleButton({
      toggleItem: onToggle,
      isItemExpanded: isExpanded,
    })) || <HeaderToggleButton isExpanded={isExpanded} onToggle={onToggle} />;

  return (
    <div className="flex items-center justify-between py-4 ">
      {children}
      {isToggleable && toggleButton}
    </div>
  );
};

export default AccordionItemHeader;
